import React from "react";
// Common Components
import TableTemplate from "./TableTemplate";
import { CommonTableUI } from "./CommonTableUI";
import { FileDownloader } from "src/Components";
// Requests
import {
  getAssetPercentageTable,
  getAssetPercentageExcelFile,
} from "src/Requests/imePortfolio";
// Types
import {
  IAssetPercentageSearchParams,
  IAssetPercentageTableReport,
} from "src/Interfaces/imePortfolio";

const AssetPercentage: React.FC = () => {
  return (
    <div className="w-full h-full p-5 ">
      <FileDownloader getFile={getAssetPercentageExcelFile} />
      <TableTemplate<IAssetPercentageSearchParams, IAssetPercentageTableReport>
        TableUI={({ reports, onAction, sortingType, setSortingType }) => {
          return (
            <CommonTableUI
              reports={reports}
              onAction={onAction}
              sortingType={sortingType}
              setSortingType={setSortingType}
              tableBoxClassName="max-h-[700px] overflow-auto"
            />
          );
        }}
        getDataTable={getAssetPercentageTable}
        withSort
      />
    </div>
  );
};

export default AssetPercentage;
